<template>
  <div v-show="$route.path == '/broadcast' || $route.path == '/schedule'|| $route.path == '/live'">
  <div v-show="isSHOW">
    <div v-show="mediaState == 2 ? false : true">
      <div class="mediaState" :style="{color:selectStatus(mediaTimeState).color,borderColor:selectStatus(mediaTimeState).color,backgroundColor:selectStatus(mediaTimeState).backGround}"
           v-show="mediaTimeState == 2 || mediaTimeState == 3">
        <i class="el-icon-control-icon_error" v-show="mediaTimeState == 3"></i>
        <i class="el-icon-control-icon_warning" v-show="mediaTimeState == 2"></i>
        {{selectStatus(mediaTimeState).text }}
        <span v-show="mediaTimeState ==  2 || mediaTimeState == 3">
        {{$t('common.company')}}{{company}}，{{$t('common.email')}}{{email}}，{{$t('common.phone')}}{{phone}}
        </span>
        <span v-show="mediaTimeState ==  1">
          {{startDate}} {{ $t('common.to') }} {{stopDate}}
        </span>
        <i class="el-icon-control-iconClose X-icon" v-show="mediaTimeState == 2" @click="isSHOW = false"></i>
      </div>
    </div>
  </div>
  </div>
</template>

<script>
import {selectMediaOrg} from '@/api/common'
import store from '@/store'
export default {
  name: "mediaState",
  data(){
    return{
      isSHOW:true,
      company:'',
      email:'',
      phone:'',
      startDate:'',
      stopDate:'',
      mediaTimeState:0,
      mediaState:1,
      language: this.$store.getters.language, // 多语言变量
    }
  },
  created() {
    this.selectMediaOrg()
  },
  watch:{
    /*$route:{
      handler(val,oldval){
        if(val.path == '/devices' || val.path == '/resources'){
          this.isSHOW = false
        }
      },
      // 深度观察监听
      deep: true,
      immediate:true
    }*/
  },
  methods:{
    selectStatus(status) {
      let color = '';
      let backGround = ''
      let text = ''
      switch (status) {
        case 0:
          color = '#6DD400';
          backGround = 'rgba(109,212,0,0.11)';
          text = this.$t('common.TrialWorkstation');
          break
        case 1:
          color = '#6DD400';
          backGround = 'rgba(109,212,0,0.11)';
          text = this.$t('common.NormalWorkstation');
          break
        case 2:
          if(this.language == 'zh'){
            text = this.$t('common.AdventWorkstationOne') + this.stopDate.split("-")[0]+ '年' + this.stopDate.split("-")[1] + '月' + this.stopDate.split("-")[2] + '日' + this.$t('common.AdventWorkstationTwo');
          }else{
            text = this.$t('common.AdventWorkstationOne') + this.stopDate.split("-")[2]+ '/' + this.stopDate.split("-")[1] + '/' + this.stopDate.split("-")[0] + this.$t('common.AdventWorkstationTwo');
          }
          color = '#f59a23';
          backGround = 'rgba(250,100,0,0.11)';
          break
        case 3:
          color = '#E02020';
          backGround = 'rgba(224,32,32,0.11)';
          text = this.$t('common.ExpiredWorkstation');
          break
      }
      return {color,text,backGround}
    },
    selectMediaOrg(){
      selectMediaOrg().then(res =>{
        let msgBody = res.jsonBody.msgBody
        store.dispatch('setmediaTimeStateObject',msgBody)
       /* this.mediaTimeState = 1;
        this.company = "测试公司";
        this.email = "test@iq.com";
        this.phone = "15555555555";
        this.stopDate = '2021-09-22';*/
        this.mediaState = msgBody.mediaState;
        this.mediaTimeState = msgBody.mediaTimeState;
        store.dispatch('setDispatchMediaTimeState',this.mediaTimeState)
        this.company = msgBody.company;
        this.email = msgBody.email;
        this.phone = msgBody.phone;
        this.startDate = msgBody.startDate;
        this.stopDate = msgBody.stopDate;
         /*if(this.mediaTimeState == 1){
          this.$notify({
            title:this.$t('common.mediaTimeStateNotifySuccessTitle'),
            message:  this.$t('common.mediaTimeStateNotifySuccessContent'),
            iconClass:'success',
            offset: 95,
            duration: 5000,
            showClose:true,
            customClass:'customClass-mediaTimeStateOne'
          });
        }*/
      })
    },
  }
}
</script>
<style  lang="scss">
/*.customClass-mediaTimeStateOne{
  left: 50% !important;
  transform: translateX(-50%);
}
.customClass-mediaTimeStateOne > .el-notification__icon {
  height: 24px;
  width: 24px;
  font-size: 24px;
  align-self: center;
}*/
.customClass-mediaTimeStateOne{
  word-wrap: break-word;
  word-break: break-all;
  left: 50% !important;
  transform: translateX(-50%);
  width: max-content;
 /* color: #17A5FF ;*/
}
.customClass-mediaTimeStateOne > .el-notification__icon {
  font-size: 24px;
  align-self: center;
}
.customClass-mediaTimeStateOne{
  .el-notification__group{
    .el-notification__title{
      font-size: 24px;
      font-family: inter;
      font-weight: 600;
      /*color: #17a5ff ;*/
      line-height: 33px;
    }
    .el-notification__content{
      font-size: 16px;
      font-family: inter;
      font-weight: 400;
      text-align: left;
      line-height: 22px;
    }
    .el-notification__closeBtn{
      /*color: #17a5ff;*/
    }
  }
}

</style>
<style scoped>
.mediaState{
  min-height: 30px;
  align-content: center;
  position: absolute;
  top: -22px;
  font-weight: 500;
  width: 100%;
  word-wrap: break-word;
  word-break: normal;
  background: #ffeeee;
  border: 1px solid ;
  border-radius: 6px;
  font-size: 14px;
  font-family: inter;
  font-weight: 500;
  text-align: center;
  line-height: 22px;
}
.X-icon{
  width: 14px;
  height: 14px;
  position: absolute;
  right: 30px;
  top: 4px;
  font-size: 0.1px;
  cursor: pointer;
}


</style>



// WEBPACK FOOTER //
// src/components/mediaTimeState/index.vue